<template>
	<div class="page-login">
		<div class="container">
			<div class="login">

				<!-- Register Box -->
				<template v-if="!isShowRegisterInfo && !isVerification">
					<!-- Subscription Header -->
					<div class="text-center mb-4">
						<div class="subscription-title">REGISTRASI PENDAFTARAN SELLER OSTOCK</div>
						<div class="subscription-subtitle">Jualan Online Tanpa Ribet Dan Tanpa Modal! Coba Sekarang!</div>
					</div>
					<!-- End Subscription Header -->

					<div class="login-box d-flex flex-column flex-md-row-reverse">
						<!-- Subscription Box -->
						<subcription-box :app-name="appName"></subcription-box>
						<!-- End Subscription Box -->

						<!-- Register Box -->
						<div class="register-box">
							<ul class="nav nav-tabs nav-fill">
								<li class="nav-item">
									<router-link class="nav-link" to="/login">
										Sign In
									</router-link>
								</li>
								<li class="nav-item">
									<router-link class="nav-link active" to="/register">
										Sign Up
									</router-link>
								</li>
							</ul>
							<!-- <div class="login-box-logo">
								<img :src="`/img/${appLogo}`" class="d-block m-auto" :alt="appName">
							</div> -->
							<div class="login-wrapper p-5">
								<div class="h4 font-weight-bold mb-4">
									Sign Up
								</div>

								<div class="mb-4">
									<button
										type="button"
										class="btn btn-light btn-block"
										@click="redirectOOLogin()">
										<img class="mr-2" :src="`/img/oo-icon.svg`" width="15px" alt="OO">
										<span>{{ $t('Sign Up With OrderOnline') }}</span>
									</button>
								</div>

								<div class="mb-3">
									<small>OR SIGN UP USING EMAIL</small>
								</div>

								<div class="login-error callout callout--danger" v-if="registerError">
									<div class="callout__content">{{ registerError }}</div>
								</div>
								<form @submit.prevent="register()" novalidate>
									<div class="form-group">
										<input type="text" name="name" class="form-control" placeholder="Full Name" v-model="name"
											@input="onNameChange"
											:class="{ 'is-invalid': isHasErrorValidation('name') }" required>
										<div class="invalid-feedback">
											Nama Wajib Diisi
										</div>
									</div>
									<div class="form-group">
										<input type="email" name="email" class="form-control" :class="{ 'is-invalid': isHasErrorValidation('email') }" placeholder="Email" v-model="email" @change="onEmailChange" required>
										<div class="invalid-feedback">
											{{ emailErrorMessage }}
										</div>
									</div>
									<div class="form-group">
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text" id="basic-addon1">+62</span>
											</div>
											<input type="text" name="phone" class="form-control" placeholder="Phone Number"
												:class="{ 'is-invalid': isHasErrorValidation('phone') }"
												v-model.trim="phone" @input="inputPhone" minlength="9" required>
											<div class="invalid-feedback">
												Nomor Telepon minimal 9 karakter
											</div>
										</div>
									</div>
									<div class="form-group">
										<input type="password" name="password" class="form-control" @input="onPasswordChange"
											:class="{ 'is-invalid': isHasErrorValidation('password') }"
											placeholder="Password" v-model="password" minlength="6" required>
										<div class="invalid-feedback">
											Password minimal 6 karakter
										</div>
									</div>
									<div class="form-group">
										<multiselect
											v-model="selectedSource"
											placeholder="How did you find out about OStock"
											:options="sourceOptions"
											label="label"
											track-by="value"
											:hide-selected="false"
											:multiple="false"
											:taggable="false"
											:show-labels="false"
											@select="sourceValidation"
										>
										</multiselect>
									</div>
									<div v-if="isOtherSource" class="form-group">
										<input type="text" class="form-control"
											placeholder="Add More Detail"
											@keyup="sourceValueValidation"
											v-model.trim="sourceValue">
										<small v-if="errorMessages.sourceValue" class="text-danger">{{ errorMessages.sourceValue }}</small>
									</div>
									<div class="form-group d-flex justify-content-center">
										<recaptcha v-if="isGoogleRecaptchaEnabled" ref="recaptcha"></recaptcha>
									</div>
									<button type="submit" class="btn btn-submit btn-primary btn-block" :class="{ 'is-loading': isRegistering }">{{ $t('Register') }}</button>
								</form>
								<!-- <div class="text-right">
									<router-link
										class="login-action"
										to="/login"
									>
										{{ $t('Already have an account? Login here') }}
									</router-link>
								</div> -->
							</div>
						</div>
						<!-- End Register Box -->
					</div>

					<!-- <div class="auth-bottom-text hidden">
						<span>Doesn't have an account? </span>
						<a href="https://buy.ostock.id/free-account?utm_source=orderonline&utm_medium=login&utm_content=text" target="_blank">Create Free Account</a>
					</div> -->
				</template>

				<!-- Register Info -->
				<div class="login-box p-5" v-if="isShowRegisterInfo && !isVerification">
					<div class="thank-you-text">
						<div class="text-bold text-center text-dark">Thank you for registering at</div>
					</div>
					<div class="login-box-logo">
						<img :src="appLogo" class="d-block m-auto" :alt="appName">
					</div>
					<div class="login-error callout callout--danger" v-if="registerFailed">
						<div class="callout__content">{{ registerFailed }}</div>
					</div>
					<div class="login-error callout callout--info" v-if="registerSuccess">
						<div class="callout__title">{{ $t('Please Check Your Email') }}</div>
						<div class="callout__content">{{ `${$t("We've send an email verification to")} ${email}` }}</div>
					</div>
					<div class="text-right">
						<router-link
							class="login-action"
							to="/login"
						>
							{{ $t('Back to Login') }}
						</router-link>
					</div>
				</div>

				<!-- Verification Info -->
				<div class="login-box p-5" v-if="isVerification">
					<div class="login-box-logo">
						<img :src="appLogo" class="d-block m-auto" :alt="appName">
					</div>
					<div class="login-error callout callout--danger" v-if="verificationFailed">
						<div class="callout__title">{{ $t('Verification Failed') }}</div>
						<div class="callout__content">{{ $t('Verification code is no longer valid or has been used before.') }}</div>
					</div>
					<div class="login-error callout callout--success" v-if="verificationSuccess">
						<div class="callout__title">{{ $t('Verification Success') }}</div>
						<div class="callout__content">{{ $t("Congratulations now you can login to your account.") }}</div>
					</div>
					<div class="is-loading" v-if="isVerifying"></div>
					<div class="mt-5" v-if="isVerifying">
						<span class="text-muted">Verifying..</span>
					</div>
					<div class="text-right">
						<router-link
							class="login-action"
							to="/login"
						>
							{{ $t('Back to Login') }}
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import userApi from '../api/user';
import {
	duplicateVar,
	getAxiosErrorMessage,
	getAxiosErrorValidation,
	getOS,
	getDeviceType,
	getBrowser,
} from '@/lib/helper';
import Recaptcha from '@/components/Recaptcha.vue';
import SubcriptionBox from '@/components/auth/SubscriptionBox.vue';
import { sourceOptions } from '@/lib/statics';

const baseUrl = process.env.VUE_APP_BASE_URL || 'https://ostock.id';

export default {
	name: 'login',
	components: {
		Recaptcha,
		SubcriptionBox,
	},
	data() {
		return {
			title: 'Register',
			name: '',
			email: '',
			phone: '',
			password: '',
			registerError: null,
			isShowRegisterInfo: false,
			isVerification: false,
			registerSuccess: false,
			registerFailed: false,
			isRegistering: false,
			validations: [],
			verificationFailed: false,
			verificationSuccess: false,
			isVerifying: false,
			ip: null,
			location: '',
			position: null,
			latitude: 0,
			longitude: 0,
			isLocating: false,
			locationData: null,
			isLocationFetched: true,
			sourceOptions,
			selectedSource: null,
			errorMessages: {
				selectedSource: '',
				sourceValue: '',
			},
			sourceValue: '',
			surveys: [
				{
					question: '',
					key: '',
					value: '',
				},
			],
		};
	},
	methods: {
		...mapActions({
		}),
		sourceValidation() {
			if (this.selectedSource === '') {
				this.errorMessages.selectedSource = 'Source Wajib Dipilih';
			} else {
				this.errorMessages.selectedSource = '';
			}
		},
		sourceValueValidation() {
			if (this.selectedSource === 'others' && this.sourceValue === '') {
				this.errorMessages.sourceValue = 'Source Wajib Diisi';
			} else {
				this.errorMessages.sourceValue = '';
			}
		},
		register() {
			const gRecaptchaResponse = document.getElementsByName('g-recaptcha-response')[0]?.value ?? '';
			const ref = this.refQuery;
			this.surveys[0] = {
				question: this.selectedSource?.question,
				key: this.selectedSource?.label,
				value: this.isOtherSource ? this.sourceValue : this.selectedSource?.label,
			};
			const metaJson = JSON.stringify(this.meta);

			if (this.isGoogleRecaptchaEnabled && gRecaptchaResponse === '') {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Recaptcha harus diisi.',
				});
			} else {
				this.isRegistering = true;
				const params = {
					name: this.name,
					email: this.email,
					phone: this.phone,
					password: this.password,
					meta: metaJson,
					surveys: this.surveys,
					g_recaptcha: gRecaptchaResponse,
				};

				if (ref !== null) {
					params.ref = ref;
				}

				const callback = (response) => {
					const message = response.message;
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Success',
						text: message,
					});
					this.isRegistering = false;
					this.isShowRegisterInfo = true;
					this.registerSuccess = true;

					this.triggerPixel();
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Failed',
						text: message,
					});
					this.validations = getAxiosErrorValidation(e);
					this.isRegistering = false;

					if (typeof window.grecaptcha !== 'undefined') {
						window.grecaptcha.reset();
					}
				};
				userApi.register(params, callback, errorCallback);
			}
		},
		triggerPixel() {
			if (!this.metaPixels || this.metaPixels.length === 0) return;

			const registerPixel = this.metaPixels.find(pixelItem => pixelItem.type === 'register');
			if (!registerPixel) return;

			const { ids: pixelIds = [], events: trackingEvents = [], enabled: isEnabled = false } = registerPixel;
			if (!isEnabled || pixelIds.length === 0 || trackingEvents.length === 0) return;

			try {
				pixelIds.forEach(pixelId => window.fbq('init', pixelId));
				trackingEvents.forEach(trackingEvent => window.fbq('track', trackingEvent));
			} catch (error) {
				const msg = getAxiosErrorMessage(error) || 'Error when triggering pixel';
				console.log(msg);
			}
		},
		isHasErrorValidation(name) {
			let hasError = false;
			if (this.validations[name] !== undefined) {
				hasError = true;
			}
			return hasError;
		},
		onNameChange() {
			if (this.isHasErrorValidation('name') && this.name.length >= 0) {
				const validations = this.validations;
				delete validations.name;
				this.validations = validations;
			}
		},
		getIp() {
			const endpoint = 'https://public.orderonline.id/ip';
			Axios.get(endpoint)
				.then((response) => {
					const ip = response.data.ip;
					this.ip = ip;
				})
				.catch(() => {
					this.isLocationFetched = true;
				});
		},
		getLocation() {
			this.isLocating = true;
			if (navigator.geolocation) {
				const onSuccess = (pos) => {
					this.position = duplicateVar(pos);
					const lat = pos.coords.latitude;
					const long = pos.coords.longitude;
					this.latitude = lat;
					this.longitude = long;
					this.isLocating = false;
				};
				const onError = () => {
					this.isLocating = false;
				};
				navigator.geolocation.getCurrentPosition(onSuccess, onError);
			} else {
				this.isLocating = false;
			}
		},
		// input phone
		inputPhone() {
			const validPhone = this.isPhoneError();
			this.phone = this.phone.replace(/[^\d]/g, '');
			if (validPhone) {
				// this.isValidateError.phone = false;
				const firstSelection = this.phone.substring(0, 1);
				const secondSelection = this.phone.substring(0, 2);
				let phone = this.phone;
				if (secondSelection === '62') {
					phone = phone.replace('62', '');
				} else if (firstSelection === '0') {
					phone = phone.replace('0', '');
				}
				this.phone = phone;

				if (this.isHasErrorValidation('phone') && this.phone.length >= 9) {
					const validations = this.validations;
					delete validations.phone;
					this.validations = validations;
				}
			}
		},
		// validate phone number
		isPhoneError() {
			return (
				this.phone.trim() !== ''
				&& !new RegExp(/^\+\d+$/).test(this.phone.trim())
			);
		},
		onEmailChange() {
			if (this.isHasErrorValidation('email')) {
				const validations = this.validations;
				delete validations.email;
				this.validations = validations;
			}
		},
		onPasswordChange() {
			if (this.isHasErrorValidation('password') && this.password >= 6) {
				const validations = this.validations;
				delete validations.password;
				this.validations = validations;
			}
		},
		validateCode() {
			this.isVerifying = true;
			const params = {
				email: this.emailQuery,
				code: this.codeQuery,
			};
			const callback = () => {
				this.isVerifying = false;
				this.verificationSuccess = true;
				// this.$router.push(`/register-verification?verified=true`)
			};
			const errorCallback = ({ response: { data } }) => {
				const errorMessage = data.message;
				this.verificationFailed = true;
				this.isVerifying = false;
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: errorMessage,
				});
				// this.$router.push(`/register-verification?verified=false&message=${errorMessage}`);
			};
			if (this.emailQuery && this.codeQuery) {
				userApi.registerValidateCode(params, callback, errorCallback);
			}
		},
		redirectOOLogin() {
			window.location = `${this.ooWeb}/auth/ostock?callback=${baseUrl}/auth/callback`;
		},
		handleOOLogin() {
			const userId = this.$route.query.uid;
			let ref = this.$route.query.ref;
			const encryptedToken = this.$route.query.secret;
			if (userId && encryptedToken) {
				if (ref === null || ref === '') {
					ref = 'orderonline';
				}

				const token = window.atob(encryptedToken);
				window.location.href = `/auth/callback?oo_user=${userId}&token=${token}&ref=${ref}`;
			}
		},
	},
	computed: {
		...mapGetters({
			appName: 'appName',
			appLogo: 'appLogo',
			ooWeb: 'ooWeb',
			metaPixels: 'metaPixels',
			isGoogleRecaptchaEnabled: 'isGoogleRecaptchaEnabled',
		}),
		isOtherSource() {
			return this.selectedSource?.value === 'others';
		},
		meta() {
			const os = getOS();
			const deviceType = getDeviceType();
			const browser = getBrowser();
			const location = this.location;
			const userAgent = window.navigator.userAgent;
			const meta = {
				ip: this.ip,
				os,
				device: deviceType,
				browser,
				location,
				lat: this.latitude,
				long: this.longitude,
				user_agent: userAgent,
			};
			return meta;
		},
		emailQuery() {
			return this.$route.query.email;
		},
		codeQuery() {
			return this.$route.query.code;
		},
		refQuery() {
			return this.$route?.query?.ref ?? null;
		},
		emailErrorMessage() {
			let message = 'Email Wajib Diisi';
			if (this.isHasErrorValidation('email') && this.validations.email[0] === 'validation.unique') {
				message = 'Email sudah terdaftar';
			}
			return message;
		},
	},
	watch: {
		ip() {
			if (this.ip) {
				const geoApiKey = process.env.VUE_APP_GEODB_API_KEY;
				const endpoint = `https://geolocation-db.com/json/${geoApiKey}/${this.ip}`;
				Axios.get(endpoint)
					.then(({ data }) => {
						this.locationData = data;
						const city = data.city || 'Unknown city';
						const country = data.country_name || 'Unknown country';
						const location = `${city}, ${country}`;
						this.location = location;
						this.isLocationFetched = true;
					})
					.catch(() => {
						this.isLocationFetched = true;
					});
			}
		},
	},
	created() {
		this.handleOOLogin();
		document.body.classList.add('login');
		this.getIp();
		this.getLocation();
		if (this.emailQuery && this.codeQuery) {
			this.isVerification = true;
			this.validateCode();
		}
	},
	destroyed() {
		document.body.classList.remove('login');
		document.removeEventListener('click', this.onClick);
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.navbar-brand {
	margin: 0 auto;
}

.login {
	padding-top: 4em;
	text-align: center;
}

.login-wrapper {
	min-width: 400px;
}

h3 {
	font-weight: 300;
}

.login-box {
	margin: 2em auto;
	// padding: 2.5em;
	// max-width: 420px;
	max-width: 952px;
	background-color: #fff;
	border-radius: 5px;
	// border: 1px solid #d7d7da;
	box-shadow: 0 1px 10px -4px #9c9c9c;

	@media (max-width: 575px) {
		margin-top: 0;
		// padding: 1em;
		box-shadow: none;
	}
}

.register-box {
	@media (max-width: 575px) {
		padding: 1em;
	}
}

.login-box-logo {
	margin: 0 auto;
	margin-bottom: 2em;
	max-width: 210px;

	img {
		max-width: 100%;
		height: auto;
	}
}

.login-error {
	margin-bottom: 2em;
	font-size: .95em;
}

.login-action {
	display: inline-block;
	margin-top: 1em;
	// color: #75cfd8 !important;
	cursor: pointer;

	&:hover {
		text-decoration: underline !important;
	}
}

.btn-submit {
	padding-top: .5em;
	padding-bottom: .5em;
	font-weight: 600;
	text-transform: uppercase;
}

.nav-tabs {
	border-bottom: 0px solid transparent;

	.nav-link {
		border: 0px solid transparent;
		padding: 0.7rem 1rem;
	}

	:last-child{
		.nav-link {
			border-right: none;
			border-top-right-radius: 5px;
		}
	}
}

.subscription-title {
	font-size: 30px;
	font-weight: 600;
	color: black;
}

.subscription-subtitle {
	font-size: 16px;
	font-weight: 400;
}

.thank-you-text {
	font-size: 2rem;
}
</style>
